import { render, staticRenderFns } from "./compose.vue?vue&type=template&id=743d59a6"
import script from "./compose.vue?vue&type=script&lang=js"
export * from "./compose.vue?vue&type=script&lang=js"
import style0 from "./compose.vue?vue&type=style&index=0&id=743d59a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports